export default {
    salaryUnit: "Đồng",
    pleaseSelect: "Vui lòng chọn",
    negotiated: "Thỏa thuận",
    unit: "Triệu",
    lessThanFiveMillion: "Dưới 5 Triệu",
    moreThanFiftyMillion: "Trên 50 Triệu",
    salaryRangePrefix: "Đến",
};
